import { Grid } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Container from '../../components/Layout/Container';
import GridContainer from '../../components/Layout/GridContainer';
import BudgetVersionSelector from '../../components/Budget/BudgetVersionSelector';
import { BudgetContextProvider, useBudgetContext } from '../../store/Budget/BudgetContext';

const BudgetVersionSelectorConnected = () => {
    const {
        selectedVersionId,
        setSelectedVersionId,
        handleDownload,
        isDownloading,
        versions,
        buckets,
        selectedBucketId,
        setSelectedBucketId,
        isVersionsLoading,
        canEdit,
    } = useBudgetContext();

    return (
        <BudgetVersionSelector
            selectedVersionId={selectedVersionId}
            onVersionChange={setSelectedVersionId}
            onDownload={handleDownload}
            isDownloading={isDownloading}
            versions={versions}
            buckets={buckets}
            selectedBucketId={selectedBucketId}
            setSelectedBucketId={setSelectedBucketId}
            isLoadingVersions={isVersionsLoading}
            canEdit={canEdit}
        />
    );
};

const BudgetLayout = () => {
    const { pathname } = useLocation();
    // CALL-745: config, prices and working-unit mapping are global/version-agnostic, so the
    // version header (version picker, publish, draft, download, year filter) belongs only on the
    // per-version Overview.
    // The consolidated view also needs a baseline version, but it picks one itself, inline above its
    // scenario multiselect: those two choices belong together (the board shows Budget then Szenarien),
    // and this header's Download/Publish/draft actions act on the plain baseline version rather than the
    // scenario-adjusted numbers that page shows.
    const showVersionSelector = pathname === '/budget' || pathname === '/budget/';

    return (
        <BudgetContextProvider>
            <Container>
                {/* CALL-815: the gap above the Overview's filter bar was mostly the version header's OWN
                    `mb: 2`, doubling the row spacing this container already provides — removed there rather
                    than compensated for here, so GridContainer keeps its standard rhythm. */}
                <GridContainer>
                    {showVersionSelector && (
                        <Grid item xs={12}>
                            <BudgetVersionSelectorConnected />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Outlet />
                    </Grid>
                </GridContainer>
            </Container>
        </BudgetContextProvider>
    );
};

export default BudgetLayout;
